/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type DayTimeSlotInput = {
    date: string;
    timeSlot: TimeSlot;
};
export type ChromeEventSuggestedTimesRendererQueryVariables = {
    orgRelayId: string;
    reschedulerExternalEventId: string;
    reschedulerTimeZone: string;
    reschedulerRangeMin: DayTimeSlotInput;
    reschedulerRangeMax: DayTimeSlotInput;
};
export type ChromeEventSuggestedTimesRendererQueryResponse = {
    readonly node: {
        readonly id: string;
        readonly reschedulingResponseErrorable?: {
            readonly " $fragmentRefs": FragmentRefs<"ChromeEventSuggestedTimes_schedulingResponseErrorable">;
        } | undefined;
        readonly " $fragmentRefs": FragmentRefs<"ChromeEventSuggestedTimes_org">;
    } | null;
};
export type ChromeEventSuggestedTimesRendererQuery = {
    readonly response: ChromeEventSuggestedTimesRendererQueryResponse;
    readonly variables: ChromeEventSuggestedTimesRendererQueryVariables;
};



/*
query ChromeEventSuggestedTimesRendererQuery(
  $orgRelayId: ID!
  $reschedulerExternalEventId: String!
  $reschedulerTimeZone: String!
  $reschedulerRangeMin: DayTimeSlotInput!
  $reschedulerRangeMax: DayTimeSlotInput!
) {
  node(id: $orgRelayId) {
    __typename
    id
    ... on Org {
      ...ChromeEventSuggestedTimes_org
      reschedulingResponseErrorable(externalEventId: $reschedulerExternalEventId, timeZone: $reschedulerTimeZone, rangeMin: $reschedulerRangeMin, rangeMax: $reschedulerRangeMax) {
        __typename
        ...ChromeEventSuggestedTimes_schedulingResponseErrorable
      }
    }
  }
}

fragment ChromeEventSuggestedTimes_org on Org {
  ...EventSchedulerSuggestedTime_org
  id
  primaryOrgCalendar
  workingGroups(first: 1000000) {
    edges {
      node {
        rooms {
          roomId
          name
          id
        }
        id
      }
    }
  }
}

fragment ChromeEventSuggestedTimes_schedulingResponseErrorable on SchedulingResponseErrorable {
  __isSchedulingResponseErrorable: __typename
  __typename
  ... on SchedulingResponse {
    uncrawledCalendars
    qualifiers
    slots {
      ...EventSchedulerSuggestedTime_schedulingSlot
      summary {
        availableRooms
        tags
        freeAttendees
        inconvenientForAttendees
        focusTimeMinutesCost
        conflictingAttendees
      }
      attendanceImpacts {
        calendarId
        inconveniences
        hasConflict
        focusTimeMinutesCost
        conflictingMeetings
      }
      roomImpacts {
        roomId
        available
      }
      timeRange {
        id
        startTime {
          type
          dateOrDateTime
          timeZone
          offsetMinutes
          millis
        }
        endTime {
          type
          dateOrDateTime
          timeZone
          offsetMinutes
          millis
        }
      }
    }
  }
  ... on GraphEntityError {
    message
    statusCode
    body
  }
}

fragment EventSchedulerSuggestedTime_org on Org {
  id
  experiments
}

fragment EventSchedulerSuggestedTime_schedulingSlot on SchedulingSlot {
  summary {
    availableRooms
    tags
    freeAttendees
    inconvenientForAttendees
    unavailableAttendees
    focusTimeMinutesCost
    conflictingAttendees
  }
  attendanceImpacts {
    calendarId
    inconveniences
    unavailabilities
    hasConflict
    focusTimeMinutesCost
    conflictingMeetings
  }
  roomImpacts {
    roomId
    available
    tooSmall
    tooLarge
  }
  timeRange {
    id
    startTime {
      type
      dateOrDateTime
      timeZone
      offsetMinutes
      millis
    }
    endTime {
      type
      dateOrDateTime
      timeZone
      offsetMinutes
      millis
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reschedulerExternalEventId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reschedulerRangeMax"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reschedulerRangeMin"
    } as any, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reschedulerTimeZone"
    } as any, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v7 = [
        {
            "kind": "Variable",
            "name": "externalEventId",
            "variableName": "reschedulerExternalEventId"
        } as any,
        {
            "kind": "Variable",
            "name": "rangeMax",
            "variableName": "reschedulerRangeMax"
        } as any,
        {
            "kind": "Variable",
            "name": "rangeMin",
            "variableName": "reschedulerRangeMin"
        } as any,
        {
            "kind": "Variable",
            "name": "timeZone",
            "variableName": "reschedulerTimeZone"
        } as any
    ], v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roomId",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "focusTimeMinutesCost",
        "storageKey": null
    } as any, v11 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeZone",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offsetMinutes",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "ChromeEventSuggestedTimesRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v5 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v6 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v7 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "reschedulingResponseErrorable",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ChromeEventSuggestedTimes_schedulingResponseErrorable"
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "ChromeEventSuggestedTimes_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v4 /*: any*/),
                (v3 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Operation",
            "name": "ChromeEventSuggestedTimesRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v5 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v8 /*: any*/),
                        (v6 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "experiments",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgCalendar",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1000000
                                        }
                                    ],
                                    "concreteType": "WorkingGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "workingGroups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WorkingGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "WorkingGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Room",
                                                            "kind": "LinkedField",
                                                            "name": "rooms",
                                                            "plural": true,
                                                            "selections": [
                                                                (v9 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "name",
                                                                    "storageKey": null
                                                                },
                                                                (v6 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v6 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "workingGroups(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v7 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "reschedulingResponseErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isSchedulingResponseErrorable"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "uncrawledCalendars",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "qualifiers",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SchedulingSlot",
                                                    "kind": "LinkedField",
                                                    "name": "slots",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SchedulingAttendanceSummary",
                                                            "kind": "LinkedField",
                                                            "name": "summary",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "availableRooms",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "tags",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "freeAttendees",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "inconvenientForAttendees",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "unavailableAttendees",
                                                                    "storageKey": null
                                                                },
                                                                (v10 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "conflictingAttendees",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SchedulingAttendanceImpact",
                                                            "kind": "LinkedField",
                                                            "name": "attendanceImpacts",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "calendarId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "inconveniences",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "unavailabilities",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "hasConflict",
                                                                    "storageKey": null
                                                                },
                                                                (v10 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "conflictingMeetings",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SchedulingRoomImpact",
                                                            "kind": "LinkedField",
                                                            "name": "roomImpacts",
                                                            "plural": true,
                                                            "selections": [
                                                                (v9 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "available",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "tooSmall",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "tooLarge",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TimeRange",
                                                            "kind": "LinkedField",
                                                            "name": "timeRange",
                                                            "plural": false,
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventTime",
                                                                    "kind": "LinkedField",
                                                                    "name": "startTime",
                                                                    "plural": false,
                                                                    "selections": (v11 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventTime",
                                                                    "kind": "LinkedField",
                                                                    "name": "endTime",
                                                                    "plural": false,
                                                                    "selections": (v11 /*: any*/),
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "SchedulingResponse",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "message",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "statusCode",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "body",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "fcb48384c6383b8f78f648e7efcbdd38",
            "id": null,
            "metadata": {},
            "name": "ChromeEventSuggestedTimesRendererQuery",
            "operationKind": "query",
            "text": "query ChromeEventSuggestedTimesRendererQuery(\n  $orgRelayId: ID!\n  $reschedulerExternalEventId: String!\n  $reschedulerTimeZone: String!\n  $reschedulerRangeMin: DayTimeSlotInput!\n  $reschedulerRangeMax: DayTimeSlotInput!\n) {\n  node(id: $orgRelayId) {\n    __typename\n    id\n    ... on Org {\n      ...ChromeEventSuggestedTimes_org\n      reschedulingResponseErrorable(externalEventId: $reschedulerExternalEventId, timeZone: $reschedulerTimeZone, rangeMin: $reschedulerRangeMin, rangeMax: $reschedulerRangeMax) {\n        __typename\n        ...ChromeEventSuggestedTimes_schedulingResponseErrorable\n      }\n    }\n  }\n}\n\nfragment ChromeEventSuggestedTimes_org on Org {\n  ...EventSchedulerSuggestedTime_org\n  id\n  primaryOrgCalendar\n  workingGroups(first: 1000000) {\n    edges {\n      node {\n        rooms {\n          roomId\n          name\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ChromeEventSuggestedTimes_schedulingResponseErrorable on SchedulingResponseErrorable {\n  __isSchedulingResponseErrorable: __typename\n  __typename\n  ... on SchedulingResponse {\n    uncrawledCalendars\n    qualifiers\n    slots {\n      ...EventSchedulerSuggestedTime_schedulingSlot\n      summary {\n        availableRooms\n        tags\n        freeAttendees\n        inconvenientForAttendees\n        focusTimeMinutesCost\n        conflictingAttendees\n      }\n      attendanceImpacts {\n        calendarId\n        inconveniences\n        hasConflict\n        focusTimeMinutesCost\n        conflictingMeetings\n      }\n      roomImpacts {\n        roomId\n        available\n      }\n      timeRange {\n        id\n        startTime {\n          type\n          dateOrDateTime\n          timeZone\n          offsetMinutes\n          millis\n        }\n        endTime {\n          type\n          dateOrDateTime\n          timeZone\n          offsetMinutes\n          millis\n        }\n      }\n    }\n  }\n  ... on GraphEntityError {\n    message\n    statusCode\n    body\n  }\n}\n\nfragment EventSchedulerSuggestedTime_org on Org {\n  id\n  experiments\n}\n\nfragment EventSchedulerSuggestedTime_schedulingSlot on SchedulingSlot {\n  summary {\n    availableRooms\n    tags\n    freeAttendees\n    inconvenientForAttendees\n    unavailableAttendees\n    focusTimeMinutesCost\n    conflictingAttendees\n  }\n  attendanceImpacts {\n    calendarId\n    inconveniences\n    unavailabilities\n    hasConflict\n    focusTimeMinutesCost\n    conflictingMeetings\n  }\n  roomImpacts {\n    roomId\n    available\n    tooSmall\n    tooLarge\n  }\n  timeRange {\n    id\n    startTime {\n      type\n      dateOrDateTime\n      timeZone\n      offsetMinutes\n      millis\n    }\n    endTime {\n      type\n      dateOrDateTime\n      timeZone\n      offsetMinutes\n      millis\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '8df4c3b7e585410b3401f0634ab88bea';
export default node;
